import { stegaClean } from '@/lib/utils/stega';
import { cn } from '@/lib/utils/tw-merge';
import { ICONS, type IconName } from './UiIcon.constants';
import type { UiIconProps } from './UiIcon.types';

export function UiIcon({ name, size, className, ...props }: UiIconProps) {
    // `name` may be a Sanity-stored value; strip stega so the key lookup works in draft mode too.
    const Icon = ICONS[stegaClean(name) as IconName];
    if (!Icon) return null;

    // Explicit `size` → fixed px box; otherwise fill the container (inherits sizing from className).
    if (size != null) {
        return <Icon width={size} height={size} className={className} {...props} />;
    }
    return <Icon className={cn('size-full', className)} {...props} />;
}
